module.exports = __webpack_public_path__ + "static/media/replacement-metal-castings-navside.021784a5.png";